import { AppConfigModel } from "../abstract/app-config.model";

export class Authorization extends AppConfigModel {

    static override CLASS_NAME: string = 'Authorization';

    readonly activity!: string;
    readonly activityLabel!: string;
    readonly activitySortOrder!: number;
    readonly app!: string;
    readonly appDescription!: string;
    readonly appLabel!: string;
    readonly description!: string;
    readonly model!: string;
    readonly modelDescription!: string;
    readonly modelLabel!: string;
    readonly labelShort!: string;
    readonly fieldsCount!: number;
}
